module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierda-di-48930f06.png";